import React from "react";
import Collapse from "../../common/Collapse";
import QuestionForm from "./QuestionForm";
import Shadow from "../../../assets/shadows/2.png";
import Misc1 from "../../../assets/misc/1.svg";
import Misc2 from "../../../assets/misc/2.svg";

const Faqs = () => {
  const data = [
    {
      title:
        "Who can participate?",
      content:
        `Anyone can make an impact - hackathons produce "hackers", not the other way around.`,
    },
    {
      title: "How much does it cost to attend?",
      content:
        `Absolutely nothing! A memorable experience, learning, networking – all for free!`,
    },
    {
      title: "How do I apply?",
      content:
        "Just hit the Registration button at the top right when applications open! You will receive an email confirming your application has been submitted and received, and you will receive another email once your application has been reviewed. If you are accepted, you will then be asked to confirm your spot. Remember to check your spam mail!",
    },
    {
      title: "Who else will be there?",
      content:
        "Students, industry professionals,mentors and more! We will be uploading a full list of mentors closer to the event.",
    },
    {
      title:
        "Can I sign up with a team?",
      content:
        "We allow team sign-ups of up to 3 people. Team registrations will cover individual details as well.",
    },
    {
      title: "What if I don’t have a team?",
      content:
        "Don’t worry, you can participate as a brilliant team of one.",
    },
    {
      title: "Do I need to know how to code?",
      content:
        "Yes! Our mentors and webinars will help you to pick up the frameworks before and during the event, but an entry level of Python will be beneficial.",
    },
    {
      title: "What about in-person and virtual participants?",
      content:
        "In-person attendance is not a requirement because this Hackathon is hybrid. However, the in-person teams will benefit from networking. The details of each location will be announced in due time.",
    },
    {
      title: "Can I work on my hack before the event?",
      content:
        "You can learn about the frameworks. But the data sets will be available only during the competition. ",
    },
    {
      title: "Can we use our data tools? Can we use other open source datasets?",
      content:
        "Yes, data tools can be used. No to data sets. Only the provided dataset can be used during the competition.",
    },
    {
      title: "Do you have other communication channels, such as Discord?",
      content: "Yes, they were shared above. Any inquiries can be sent to hello@oblivious.ai",
    },
    {
      title: "What COVID-19 precautions will be in place at the event?",
      content:
        "We will be following the guidance put forth by the Government for large events at the time of the event. More details will follow closer to the event and any major changes to guidelines or precautions will be communicated to event participants. Please note that majority of the participants will be joining virtually for the event.",
    },
  ];

  return (
    <div className="relative">
      <div className="sm:max-w-container max-w-[90vw] flex flex-col items-center mx-auto my-[150px] bg-white md:py-[150px] pb-24 pt-36 rounded-[48px] relative z-10">
        <div className="mx-[min(10%,106px)] w-fit">
          <img
            src={Misc1}
            className="absolute top-[84px] lg:left-[125px] left-[5%] scale-[80%] sm:scale-100"
            alt=":( Not Found"
          />
          <p className="uppercase font-semibold text-sm text-warning text-center mb-8">
            FAQs
          </p>
          <p className="relative font-semibold md:text-5xl sm:text-4xl text-3xl text-dark leading-tight md:mb-[100px] mb-16 text-center">
            Frequently Asked Questions
            <img
              src={Misc2}
              className="absolute -top-12 md:-right-16 -right-10 scale-[80%] sm:scale-100 "
              alt=":( Not Found"
            />
          </p>
        </div>
        
        <ul className="w-full md:mb-[150px] mb-[100px] px-[5%] md:px-[106px]">
          {data.map((faq, index) => (
            <li key={index} className="mb-[30px]">
              <Collapse {...faq} />
            </li>
          ))}
        </ul>

        <QuestionForm />
      </div>
      <img
        src={Shadow}
        alt=":( Not Found"
        className="absolute right-0 bottom-0 translate-y-1/2"
      />
    </div>
  );
};

export default Faqs;
